import { all, put, take } from 'redux-saga/effects';

import { PIPEROUTER__PAGES } from 'PipeRouter';
import goToPage from './goToPage';


function* pipeline() {
  while (true) {
    const { data:{ cmd, data}} = yield take(PIPEROUTER__PAGES);

    yield put({ type: cmd, data });
  }
}


export default function* pages() {
  yield all([
    pipeline(),
    goToPage()
  ]);
}
